import React from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import ConnectWallet from 'components/Header/connectWallet';
import NotConnectedPng from 'assets/images/dashboard/not-connected.png';
import { Board, Card } from '../styled';

const ConnectWalletButton = styled(ConnectWallet)`
    min-width: 135px !important;
    height: 36px !important;
    border-radius: 16px;
    font-size: 12px !important;
`;

const Blank = () => {
    return (
        <Board
            style={{
                ...(isMobile
                    ? {
                          width: '100%',
                      }
                    : {}),
            }}
        >
            <Card
                background="transparent"
                padding={isMobile ? '20px' : '45px'}
                height={isMobile ? '400px' : '450px'}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    boxShadow: '0px 22.5px 30px 0px rgba(54, 103, 123, 0.05)',
                    backdropFilter: 'blur(45px)',
                    borderRadius: '12px',
                }}
            >
                <img
                    src={NotConnectedPng}
                    alt="Not Connected"
                    width={84}
                    height={94}
                    style={{ marginBottom: '20px' }}
                />
                <ConnectWalletButton connected={false} walletAddress={''} />
            </Card>
        </Board>
    );
};

export default Blank;
